import React from 'react';
import {formatDistanceToNowStrict} from 'date-fns';
import {useLocalizationContext} from 'app/hooks';

export const TimeAgo = ({date}: {date: Date}) => {
    const {t} = useLocalizationContext();
    return <span>{`${formatDistanceToNowStrict(date)} ${t('components.timeAgo.ago')}`}</span>;
};
